export function useLocalStorage() {
  const getStorageItem = <Type>(key: string): Type | null => {
    if (typeof Storage !== 'undefined') {
      const item = localStorage.getItem(key)
      if (item) {
        return JSON.parse(item)
      }
    }

    return null
  }

  const setStorageItem = (key: string, value: unknown) => {
    if (typeof Storage !== 'undefined') {
      return localStorage.setItem(key, JSON.stringify(value))
    }

    return null
  }

  const removeStorageItem = (key: string) => {
    if (typeof Storage !== 'undefined') {
      localStorage.removeItem(key)
    }
  }

  return {
    setStorageItem,
    getStorageItem,
    removeStorageItem,
  }
}
